module.exports = __webpack_public_path__ + "static/img/lgxkskkzz_opcity.f6ef28d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lgxkskkzz_opcity.jpg
// module id = flAe
// module chunks = 1